// @flow
import type {DataTables} from 'datatables.net';

export default function roadshowRequestSlot(column: String, options: any, dtSettings: DataTables.Settings, component: JQuery) {
    dtSettings.columns.find(c => c.title == column).roadshowRequestSlot = (options == null ? true : options);
    $('body').on('click', '.request-slot', function () {
        let roadshowId = $(this).data('roadshow-id')
        
        let buttonContent = $(this).text()
        $(this).html(buttonContent + ' <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>')

        function requestDone(button){
            button.addClass('btn-success')
            button.html('Request Sent! <i class="fa fa-check" aria-hidden="true"></i>')
        }
        setTimeout(requestDone, 1500, $(this));
    })
}